import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";
import { Button } from "../../components/ui/button/index.js";
import { SimpleTooltip } from "../../components/ui/tooltip/index.js";
import { cn } from "../../lib/utils.js";

export function ReportRefreshButton({
  refreshing,
  disabled,
  onRefresh,
  testId,
}: {
  refreshing: boolean;
  disabled?: boolean;
  onRefresh: () => void;
  testId?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const label = refreshing ? t("reports.chrome.refreshing") : t("reports.chrome.refresh");
  const isDisabled = disabled || refreshing;

  return (
    <SimpleTooltip content={label}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="size-8 p-0"
        disabled={isDisabled}
        aria-label={label}
        aria-busy={refreshing || undefined}
        data-testid={testId ?? "reports-refresh"}
        onClick={() => {
          if (isDisabled) return;
          onRefresh();
        }}
      >
        <RefreshCw
          size={14}
          aria-hidden="true"
          className={cn(refreshing && "animate-spin motion-reduce:animate-none")}
        />
      </Button>
    </SimpleTooltip>
  );
}
